export default {
    PASSWORD: 'Password',
    LOCATION: 'Location',
    SIZE_LOCATION: 'Size-Location',
    VRBO: 'Vrbo',
    DEFAULT: 'Default',
    TIMEOUT: 'Timeout'
};
